import { createSlice } from "@reduxjs/toolkit";
import { getPpdbList, savePpdb, deletePpdb } from "../controller/ppdb.controller";
import { Ppdb } from "../types/ppdbType";
import { SaveResponse } from "../types/common";

interface PpdbState {
  loading: boolean;
  list: Ppdb[];
  total: { pages: number; data: number };
  response: SaveResponse | null;
  error: string | null;
}

const initialState: PpdbState = {
  loading: false,
  list: [],
  total: { pages: 0, data: 0 },
  response: null,
  error: null,
};

const ppdbSlice = createSlice({
  name: "ppdb",
  initialState,
  reducers: {
    resetPpdbResponse: (state) => {
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPpdbList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPpdbList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data?.data ?? [];
        state.total = action.payload.data?.total ?? { pages: 0, data: 0 };
      })
      .addCase(getPpdbList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal memuat data PPDB";
      })
      .addCase(savePpdb.pending, (state) => {
        state.loading = true;
      })
      .addCase(savePpdb.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;
      })
      .addCase(savePpdb.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal menyimpan PPDB";
      })
      .addCase(deletePpdb.fulfilled, (state, action) => {
        state.response = action.payload;
      });
  },
});

export const { resetPpdbResponse } = ppdbSlice.actions;
export default ppdbSlice.reducer;
